import { takeEvery, takeLatest } from 'redux-saga/effects';
import { emailTemplatesActions } from '../redux';
import {
    fetchTemplatesSaga,
    createTemplateSaga,
    updateTemplateSaga,
    deleteTemplateSaga,
    fetchPickerOptionsSaga,
    applyTemplateSaga,
} from './saga';

export function* emailTemplatesSagas() {
    yield takeLatest(
        emailTemplatesActions.fetchTemplates.type,
        fetchTemplatesSaga
    );
    yield takeEvery(
        emailTemplatesActions.createTemplate.type,
        createTemplateSaga
    );
    yield takeEvery(
        emailTemplatesActions.updateTemplate.type,
        updateTemplateSaga
    );
    yield takeEvery(
        emailTemplatesActions.deleteTemplate.type,
        deleteTemplateSaga
    );
    yield takeLatest(
        emailTemplatesActions.fetchPickerOptions.type,
        fetchPickerOptionsSaga
    );
    yield takeLatest(
        emailTemplatesActions.applyTemplate.type,
        applyTemplateSaga
    );
}
